import { Phone, CalendarCheck } from "lucide-react";
import { scrollToId, PHONE_TEL } from "@/lib/site";

export const MobileBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-2 border-t border-white/10 bg-brand-navy/90 p-3 backdrop-blur-xl md:hidden">
    <a
      data-testid="mobile-sticky-call-button"
      href={PHONE_TEL}
      className="flex items-center justify-center gap-2 rounded-xl border border-white/20 py-3 text-sm font-bold text-white"
    >
      <Phone className="h-4 w-4" /> Call Now
    </a>
    <button
      data-testid="mobile-sticky-book-button"
      onClick={() => scrollToId("book")}
      className="flex items-center justify-center gap-2 rounded-xl bg-fall-amber py-3 text-sm font-bold text-brand-navy"
    >
      <CalendarCheck className="h-4 w-4" /> Book Pickup
    </button>
  </div>
);
